export var IdExternalBarnCategory;
(function (IdExternalBarnCategory) {
    IdExternalBarnCategory[IdExternalBarnCategory["Upgrade"] = 0] = "Upgrade";
})(IdExternalBarnCategory || (IdExternalBarnCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/external-barn/IdExternalBarnCategory.ts
// module id = 925
// module chunks = 3